/**
 * ISO 646 national character set variants for TDV2200.
 */
export const enum TDV2200ISO646Variant {
  International = 0,  // US ASCII
  Norwegian = 1,
  Swedish = 2,
  German = 3,
}
